"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Heap = _interopRequireDefault(require("./Heap"));
var _VWO = _interopRequireDefault(require("./VWO"));
var _analyticsConstants = require("./analyticsConstants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class Analytics extends _react.Component {
  render() {
    const {
      program,
      member,
      heapId,
      vwoAccntId
    } = this.props;
    const heapProps = {
      program,
      member,
      heapId
    };
    const vwoProps = {
      vwoAccntId
    };
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Heap.default, heapProps), /*#__PURE__*/_react.default.createElement(_VWO.default, vwoProps));
  }
}
exports.default = Analytics;
Analytics.propTypes = {
  /** Program object. Will fire HEAP.identify if passed [key, ocid, name] */
  program: _propTypes.default.shape({
    key: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
    ocid: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
    name: _propTypes.default.string
  }),
  /** Member object. Will fire FS.identify and HEAP.identify if passed [member_key, member_id, first_name, last_name, email] */
  member: _propTypes.default.shape({
    member_key: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
    member_id: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
    first_name: _propTypes.default.string,
    last_name: _propTypes.default.string,
    email: _propTypes.default.string
  }),
  /** Heap account Id [991350086] */
  heapId: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  /** VWO account Id [310341] */
  vwoAccntId: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
};
Analytics.defaultProps = {
  program: _analyticsConstants.PROGRAM,
  member: _analyticsConstants.MEMBER,
  heapId: _analyticsConstants.HEAP_ACCOUNT_ID,
  vwoAccntId: _analyticsConstants.VWO_ACCOUNT_ID
};